import React, { useEffect, useState } from "react";
import { useAuthState } from "../provider/AuthProvider";
import { Select } from "antd";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

function SelectOrderCar({
    value,
    onChange,
    onChangeInfo,
}: {
    value?: string;
    onChange?: (value: string) => void;
    onChangeInfo?: (value: Types.CarDto) => void;
}) {
    const { Option } = Select;
    const [orderCars, setOrderCars] = useState<Array<Types.CarDto>>([]);

    useEffect(() => {
        requestGetOrderCars();
    }, []);

    const requestAxiosGetOrderCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.CARS_URL);
        return response.data;
    };

    const {
        loading: loadingGetOrderCars,
        error: errorGetOrderCars,
        data: resultGetOrderCars,
        execute: requestGetOrderCars,
    } = useAsyncAxios(requestAxiosGetOrderCars);

    useEffect(() => {
        if (resultGetOrderCars === null) return;
        console.log("resultGetOrderCars", resultGetOrderCars);

        setOrderCars(resultGetOrderCars.cars);
    }, [resultGetOrderCars]);

    useEffect(() => {
        if (errorGetOrderCars === null) return;

        console.log("errorGetOrderCars", errorGetOrderCars);
    }, [errorGetOrderCars]);

    useEffect(() => {
        console.log("orderCars", orderCars);
    }, [orderCars]);

    const onChangeOrderCar = (value: string) => {
        onChange !== undefined && onChange(value);

        const data = orderCars.filter((car) => car.carNumber === value)[0];
        onChangeInfo !== undefined && onChangeInfo(data);
    };

    return (
        <Select value={value} onChange={onChangeOrderCar} placeholder="차량 선택" showSearch allowClear>
            {orderCars.length > 0
                ? orderCars.map((option) => {
                      return (
                          <Option key={option.carId} value={option.carNumber}>
                              {option.carNumber}
                          </Option>
                      );
                  })
                : null}
        </Select>
    );
}

export default SelectOrderCar;
